module.exports = __webpack_public_path__ + "img/school_community_portal_access.0b04113e.svg";